/**
 * The date-fns weekday token for the portal language: "Wed" in English; in Russian the two letters a calendar uses («ср»),
 * not date-fns' abbreviated «срд» (founder Q-ru-weekday A, 2026-10-12 — the app writes it the same way).
 */
export const weekdayToken = (locale: string | undefined): string =>
  (locale ?? '').toLowerCase().startsWith('ru') ? 'EEEEEE' : 'EEE';
